var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInfoIconSmall = function SvgInfoIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.168A6.168 6.168 0 108 1.831a6.168 6.168 0 000 12.337zM15.168 8A7.17 7.17 0 018 15.168 7.17 7.17 0 01.832 8 7.17 7.17 0 018 .832 7.17 7.17 0 0115.168 8zM8 8.5a.498.498 0 01-.5-.5V5.332a.501.501 0 011 0V8c0 .277-.223.5-.5.5zm0 2.668a.501.501 0 000-1h-.008a.501.501 0 000 1zm0 0",
    fillRule: "evenodd",
    fill: "#192c50"
  })));
};
export default SvgInfoIconSmall;